import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExternalUrl } from 'libs/shared/src/lib/constants/external-url';
import { BetaDisclaimerDialogComponent } from '../../../dialogs/beta-disclaimer-dialog/beta-disclaimer-dialog.component';

@Component({
  selector: 'jsg-environment-sash',
  templateUrl: './environment-sash.component.html',
  styleUrls: ['./environment-sash.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentSashComponent {
  ExternalUrl = ExternalUrl;

  constructor(private dialog: MatDialog) {}

  onDetails() {
    this.dialog.open(BetaDisclaimerDialogComponent, {
      width: '800px',
      autoFocus: false,
      disableClose: false,
    });
  }
}
